import React from 'react';
export var Menu = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { width: "22", height: "14", viewBox: "0 0 22 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1.25 13.0029L20.75 13.0029", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M1.25 7.00293L20.75 7.00293", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M1.25 1.00293L20.75 1.00293", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
